/* RESPONSIBLE TEAM: team-self-serve */
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class OperatorIndexRoute extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;

  private get isOperatorEnabled(): boolean {
    return this.appService.app?.canUseFeature('team-self-serve-ai-onboarding') ?? false;
  }

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-self-serve',
      react: this.isOperatorEnabled,
    };
  }

  beforeModel() {
    if (!this.isOperatorEnabled) {
      this.router.replaceWith('apps.app.automation');
    }
  }
}
